
<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

import SetHomeDealership from "./SetHomeDealership/SetHomeDealership.vue";

useBackButton( true, true );

</script>

<template>

    <div class="w-full h-full">
        <SetHomeDealership />
    </div>   
    
</template>
